import { useCallback, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const SEEN_KEY_PREFIX = 'welcome_seen:';

// Order matters: the first matching code wins. Generic codes (e.g. new_user) go last.
const WELCOME_CODES_BY_PRIORITY = ['new_user'];

export function useWelcomeModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [welcomeCode, setWelcomeCode] = useState<string | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const consumed = useRef(false);

  useEffect(() => {
    if (consumed.current) return;

    const codes = searchParams.getAll('welcome');
    if (codes.length === 0) return;

    const code = WELCOME_CODES_BY_PRIORITY.find((c) => codes.includes(c));
    if (!code) return;

    consumed.current = true;
    searchParams.delete('welcome');
    setSearchParams(searchParams, { replace: true });

    if (!localStorage.getItem(`${SEEN_KEY_PREFIX}${code}`)) {
      setWelcomeCode(code);
      setIsOpen(true);
    }
  }, [searchParams, setSearchParams]);

  const close = useCallback(() => {
    setIsOpen(false);
    if (welcomeCode) {
      localStorage.setItem(`${SEEN_KEY_PREFIX}${welcomeCode}`, 'true');
    }
  }, [welcomeCode]);

  return { welcomeCode, isOpen, close };
}
